import { getBackendBaseUrl } from './apiUtils';
import 'whatwg-fetch';

export const brandNameApi = async (token: string) => {
  const telehealthBaseURL = getBackendBaseUrl();
  const data = await fetch(`${telehealthBaseURL}/brand?token=${token}`, {
    method: 'GET',
  });

  if (data.status !== 200) {
    throw new Error('Failed API brand-name');
  }

  const { brandName } = await data.json();
  return brandName ? brandName : '';
};
